export var hebei = {
  imgObj: {
    gv_rights_img:
      'https://img01.yzcdn.cn/upload_files/2021/07/07/Fly-6MiyejpuXW3JqlZnqOldgsNB.png',
    gv_detail_img:
      'https://img01.yzcdn.cn/upload_files/2021/07/12/FlExCh27WeStypDUyxXt1LJ6tTK4.png',
    sv_rights_img:
      'https://img01.yzcdn.cn/upload_files/2021/07/07/FtDB3mjBFQ48E8smBXvSmVy5YJlZ.png',
    sv_detail_img:
      'https://img01.yzcdn.cn/upload_files/2021/08/19/Fq6ISwUEvQ_jXbaKskIqB5zE-b3M.png',
    counselor_bg_img:
      'https://img01.yzcdn.cn/upload_files/2021/08/03/Fu-QaiBf_GAguSlq4-O5bel37Xc5.png'
  },
  logo:
    'https://media.oss.leziedu.com/webapp/logo/%E5%AD%90%E8%A1%BF%E6%95%99%E8%82%B2LOGO-02(1).png'
}
export var shanxi = {
  imgObj: {
    gv_rights_img:
      'https://img01.yzcdn.cn/upload_files/2021/07/07/FoLiS3_CqZ8kpbRTIvaKHCtbZYlE.png',
    gv_detail_img:
      'https://img01.yzcdn.cn/upload_files/2021/07/12/FlExCh27WeStypDUyxXt1LJ6tTK4.png',
    sv_rights_img:
      'https://img01.yzcdn.cn/upload_files/2021/07/07/Fr2oSWMO1u3nIswvAkIQ7Kmw08Eh.png',
    sv_detail_img:
      'https://img01.yzcdn.cn/upload_files/2021/07/12/Fs058mGp5UIEzckZKz8GIhPeH47p.png',
    counselor_bg_img:
      'https://img01.yzcdn.cn/upload_files/2021/08/03/Fihj6ZmGmTrmPFWsmGzeFg_VthPt.png'
  },
  logo:
    'https://media.oss.leziedu.com/webapp/logo/%E5%B1%B1%E8%A5%BF%E6%96%B0%E5%8D%8E%E4%B9%90%E5%AD%90%E4%BD%9C%E4%B8%9A%E8%BE%85%E5%AF%BC%E5%B9%B3%E5%8F%B0logo1.png'
}
